import { render, staticRenderFns } from "./SchoolUserNum.vue?vue&type=template&id=4e205e06&scoped=true"
import script from "./SchoolUserNum.vue?vue&type=script&lang=js"
export * from "./SchoolUserNum.vue?vue&type=script&lang=js"
import style0 from "./SchoolUserNum.vue?vue&type=style&index=0&id=4e205e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e205e06",
  null
  
)

export default component.exports